<template>
  <div class="d-flex flex-column pa-4" :class="[{ selected: selected }]">
    <div class="d-flex align-center justify-center">
      <v-card class="fill-width padding-5" height="150px" tile width="255px" flat>
        <v-img aspect-ratio="1.7" :src="currentthumbnail" />
      </v-card>
    </div>

    <div class="d-flex mt-2">
      <div class="pb-1">
        <strong>{{ mapItem.name || mapItem.title }}</strong>
        <p class="text-caption ma-0">
          <span v-if="item.updated_at">
            Ngày cập nhập:
            {{ mapItem.updated_at }}
          </span>
        </p>
      </div>
      <div class="mt-auto ml-auto">
        <div class="text-center d-flex">
          <base-button v-if="!disableUpdate" :bindIcon="{ small: true }" icon small type-action="update"
            @click.stop="$emit('click:update', mapItem)">
          </base-button>
          <base-button v-if="!item.default && !disableUpdate" :bindIcon="{ small: true }" icon small
            type-action="delete" @click.stop="$emit('click:delete', mapItem)">
          </base-button>
        </div>
      </div>
    </div>
    <div>
      <v-chip v-if="item.default" class="mt-4" color="green" text-color="white">
        Mặc định
      </v-chip>
      <v-checkbox v-else v-model="setdefault" label="Đặt làm mặc định"></v-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    item: { type: Object, default: () => ({}) },
    selected: Boolean,
    disableUpdate: Boolean,
    disableDelete: Boolean,
  },
  data: () => ({
    imageUrl: '',
    setdefault: false,
    loading: true,
  }),
  computed: {
    mapItem() {
      return this.item
    },
    currentthumbnail() {
      if (this.mapItem.thumbnail) {
        return this.mapItem.thumbnail
      }
      return '/static/img/icon-stack.png'
    },
  },
  watch: {
    setdefault: function () {
      this.$emit('click:setDefault', this.item)
    }
  },
  methods: {},
}
</script>
<style lang="scss">
.button_style {
  &.width {
    width: 85px;
  }

  &.border_r {
    border-right: 1px solid #0000001f;
  }
}

.btn-action {
  width: fit-content;
  overflow: hidden;
  border-radius: 8px;
}
</style>
